exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading h4[data-v-5110a431]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.panel-flat[data-v-5110a431]{overflow-x:hidden!important}.address-card[data-v-5110a431]{background-color:#ffebee;border:1px solid #ffcdd2;border-radius:8px;padding:12px}.address-card-title[data-v-5110a431]{font-weight:700;font-size:15px;margin-bottom:8px}.address-card-description[data-v-5110a431]{white-space:pre-line}.note-card-description[data-v-5110a431]{background-color:#f7f9fc;border:1px solid #e2e8f0;border-radius:8px;padding:12px;margin-bottom:10px;color:#334155;white-space:pre-line;box-shadow:0 1px 2px rgba(16,24,40,.06)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5110a431","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/newShipOnly.vue
// module id = 849
// module chunks = 0